import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import Icon from '../../Icon'

export default function SelectComponent({ value, options = [], onChange, placeholder = '描述内容' }) {
  const [selected, setSelected] = useState(value || placeholder)
  const [open, setOpen] = useState(false)
  const [pos, setPos] = useState({ top: 0, left: 0 })
  const btnRef = useRef(null)

  useEffect(() => {
    if (value !== undefined && value !== '') setSelected(value)
  }, [value])

  // Close on outside click
  useEffect(() => {
    if (!open) return
    const handler = e => {
      if (btnRef.current && !btnRef.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  const handleMouseDown = e => {
    e.stopPropagation()
    e.preventDefault()
    if (!open) {
      const rect = btnRef.current.getBoundingClientRect()
      setPos({ top: rect.bottom + window.scrollY + 4, left: rect.left + window.scrollX })
    }
    setOpen(v => !v)
  }

  const handleSelect = (opt, e) => {
    e.stopPropagation()
    setSelected(opt)
    setOpen(false)
    onChange?.(opt)
  }

  return (
    <>
      <button
        ref={btnRef}
        className="fdai-structured-select"
        onMouseDown={handleMouseDown}
      >
        <span>{selected}</span>
        <Icon type="zykj-xiala" className="fdai-structured-select-arrow" />
      </button>
      {open && createPortal(
        <ul
          className="fdai-structured-select-menu"
          style={{ position: 'absolute', top: pos.top, left: pos.left }}
          onMouseDown={e => e.stopPropagation()}
        >
          {options.map(opt => (
            <li
              key={opt}
              className={`fdai-structured-select-menu-item${opt === selected ? ' active' : ''}`}
              onMouseDown={e => handleSelect(opt, e)}
            >
              {opt}
            </li>
          ))}
        </ul>,
        document.body
      )}
    </>
  )
}
